import { SandtableGroupItem } from '@modules/sandTable/components/GroupWidget';
import { SANDTABLE_GROUP_SETTINGS } from '@modules/sandTable/constants';
import { $tourData } from '@stores/dataStores';
import { $GateSandTable, $GateSandTableId } from '@stores/editingStores';
import classNames from 'classnames';
import { useStore, useStoreMap } from 'effector-react';
import {
  isSTImage,
  isSTMap,
  isSTMatrix,
} from '../../../sandTable/utils/sandTableTypeCheck';
import { LayerMap } from './LayerMap';
import { LayerMatrix } from './LayerMatrix';

export function SandTableLayer() {
  const editing = useStore($GateSandTable.state);
  const id = useStore($GateSandTableId.state);
  const { data, list } = useStoreMap({
    store: $tourData,
    keys: [id, editing?.list],
    fn: (state) => {
      if (!id || !editing) return {};
      const stData = state.sandBox?.find((item) => item.id === id) ?? null;
      const stList =
        editing.list?.map((sId) => {
          return {
            name: state.sandBox?.find((item) => sId === item.id)?.name ?? '',
            isActive: sId === id,
          };
        }) ?? [];
      return {
        data: stData,
        list: stList,
      };
    },
  });

  const renderGroup = () => {
    if (!data) return;
    const { groupList, groupSettings } = data;
    if (!groupList?.length) return null;
    const {
      type = SANDTABLE_GROUP_SETTINGS.type,
      bgColor = SANDTABLE_GROUP_SETTINGS.bgColor,
      fontColor = SANDTABLE_GROUP_SETTINGS.fontColor,
      activeFontColor = SANDTABLE_GROUP_SETTINGS.activeFontColor,
    } = groupSettings ?? {};

    return (
      <div
        className="absolute bottom-30 rounded p-10 flex items-center select-none gap-10"
        style={{
          backgroundColor: `rgba(${bgColor})`,
          backdropFilter: 'blur(10px)',
        }}
      >
        {groupList.map((item) => (
          <SandtableGroupItem
            key={item.id}
            item={item}
            color={fontColor}
            activeColor={activeFontColor}
            showIcon={type === 1}
          />
        ))}
      </div>
    );
  };

  const renderSandTable = () => {
    if (!data) return;

    if (isSTMap(data)) {
      return (
        <>
          <LayerMap data={data} />
          {renderGroup()}
        </>
      );
    }
    if (isSTImage(data) || isSTMatrix(data)) {
      return (
        <>
          <LayerMatrix data={data} />
          {renderGroup()}
        </>
      );
    }
  };

  const renderList = () => {
    if (!list) return;
    return (
      <div className="absolute right-15">
        {list.map(({ name, isActive }, i) => (
          <div
            key={i}
            className={classNames(
              'w-90 h-30 px-10 truncate mb-10 text-white text-center rounded select-none',
              {
                'bg-blue': isActive,
                'bg-black-black bg-opacity-50': !isActive,
              }
            )}
            style={{ lineHeight: '30px' }}
          >
            {name}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="absolute inset-0 bg-black-#28 flex items-center justify-center flex-col">
      {!data && (
        <>
          <div className="text-xl">还未添加开场沙盘</div>
          <div className="text-black-gray mt-5">
            在任何场景中都可以随时切至开场沙盘进行查看
          </div>
        </>
      )}
      {renderSandTable()}
      {renderList()}
    </div>
  );
}
